/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import {
    Button, Form, Input, notification
} from 'antd';
import { connect } from 'react-redux';
import { signIn } from '../../redux/actions/authActions';
import get from 'lodash/get';
import { bool, func } from 'prop-types';
import Logo from '../../assets/smartLync Black.png';
import history from '../../services/history'
import { EyeInvisibleOutlined, EyeOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import * as constants from '../../utils/constants';
import crcEvansLogo from '../../assets/crc-evans-logo.png';
import crcEvansLogoArchive from '../../assets/crc-evans-logo-archive.png';

const Login = ({ onSignIn, showLoader, authChallenge }) => {
    const [loginForm] = Form.useForm();
    const [credential, setCredentials] = useState();

    const validateCreds = () => {
        loginForm
            .validateFields()
            .then(async (creds) => {
                await login(creds);
            });
    };

    const login = async (credentials) => {
        setCredentials(credentials);
        try {
            await onSignIn(credentials);
        } catch (error) {
            notification.destroy();
            notification.error({
                message: error.message,
            });
        }
    };

    useEffect(() => {
        if (authChallenge !== '') {
            if (authChallenge === constants.CHALLENGE_NAME) {
                history.push('/reset-password', {
                    email: credential ? credential.username : '',
                    isRedirectedFromLogin: true,
                });
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [authChallenge]);

    return (
        <div className="login-page-centered" style={{ width: '100%', minHeight: '100vh', background: '#F5F6F8' }}>
            <div
                className="login-page-center-wrap"
                style={{
                    minHeight: '100vh',
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '32px 16px',
                    boxSizing: 'border-box',
                }}
            >
                <div
                    className="login-form login-form--centered"
                    style={{
                        width: '100%',
                        maxWidth: '420px',
                        margin: '0 auto',
                        height: 'auto',
                        position: 'relative',
                    }}
                >
                    <div className="login-brand-stack">
                        <img
                            src={crcEvansLogoArchive}
                            alt="CRC Evans"
                            className="login-crc-logo"
                            onError={(e) => { e.currentTarget.src = crcEvansLogo; }}
                        />
                        <img
                            src={Logo}
                            alt="SmartLync"
                            className="login-smartlync-logo"
                            style={{ width: 160, maxHeight: 56, height: 'auto' }}
                        />
                    </div>

                    <h1 className="mb-4 text-center">Sign in to Your Account</h1>

                    <Form
                        form={loginForm}
                        name="normal_login"
                        initialValues={{
                            remember: true,
                        }}
                    >
                        <Form.Item
                            name="username"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input your email address!',
                                },
                                {
                                    pattern: constants.EMAIL_PATTERN,
                                    message: 'Provide a valid email.',
                                }
                            ]}
                        >
                            <Input size="large" placeholder="Email address" />
                        </Form.Item>
                        <Form.Item
                            name="password"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input your Password!',
                                },
                            ]}
                            style={{ marginBottom: 0 }}
                        >
                            <Input.Password
                                size="large"
                                type="password"
                                placeholder="Password"
                                iconRender={visible => (visible ? <EyeOutlined className='password_icon' /> : <EyeInvisibleOutlined className='password_icon' />)}
                            />
                        </Form.Item>
                        <div className="fgt-pswd">
                            <Form.Item noStyle>
                                <Link className="login-form-forgot fw-bold" to="/forgot-password">
                                    Forgot password?
                                </Link>
                            </Form.Item>
                        </div>
                        <Form.Item>
                            <Button
                                size="large"
                                block
                                htmlType="submit"
                                type="primary"
                                className="login-form-button"
                                onClick={validateCreds}
                                disabled={showLoader}
                                loading={showLoader}
                            >
                                Sign In
                            </Button>
                        </Form.Item>
                    </Form>
                    <span className='login_copy'>
                        Powered by CRC Evans © {new Date().getFullYear()} |{' '}
                        <a href='https://www.crcevans.com/privacy-policy/' rel="noreferrer" target='_blank'>Privacy Policy</a>
                    </span>
                </div>
            </div>
        </div>
    );
};

Login.propTypes = {
    onSignIn: func.isRequired,
    showLoader: bool.isRequired
};

const mapStateToProps = ({ auth }) => {
    const showLoader = get(auth, 'isLoginLoading', false);
    const authChallenge = get(auth, 'challengeName', '');
    return {
        showLoader,
        authChallenge
    };
};

const mapDispatchToProps = {
    onSignIn: signIn,
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);
